import React, { useEffect, useState, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DadosSolicitacao from 'views/WizardDemanda/DadosSolicitacao';
import ItensCirurgia from 'views/WizardDemanda/ItensCirurgia';
import Resumo from 'views/WizardDemanda/Resumo';
import ConfirmacaoPedido from 'views/WizardDemanda/ConfirmacaoPedido';
import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { Dialog } from 'primereact/dialog';
import { Button as ButtonPrime } from 'primereact/button';
import { isMobile } from 'react-device-detect';
import { FaSpinner } from 'react-icons/fa';
import 'assets/css/geral.css';
import { Toast } from 'primereact/toast';
import Parser from 'html-react-parser';
import { iniciaPilhaPendencias, getConfiguracoes } from './ValidacaoWizard';
import PacientePedidoPadrao from './components/InformacoesPaciente/PacientePedidoPadrao';
import { dominioDemandaCirurgica } from '../../config/database';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: '80vw',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const steps = ['Paciente', 'Solicitação', 'Cirurgia', 'Resumo'];
const stepInicial = 0;

export default function Wizard() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [redireciona, setRedireciona] = useState(false);
  const [displayBasic, setDisplayBasica] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tituloErro, setTituloErro] = React.useState('');
  const [abrirMensagemErro, setAbrirMensagemErro] = useState(false);
  const [mensagemErro, setMensagemErro] = useState('');
  const [configuracoes, setConfiguracoes] = useState(null);
  const [abrirDialogConfirmacaoResetaPaciente, setAbrirDialogConfirmacaoResetaPaciente] = useState(
    false
  );
  const [abrirDialogConfirmacaoSalaCirurgica, setAbrirDialogConfirmacaoSalaCirurgica] = useState(
    false
  );

  const myToast = useRef(null);

  useEffect(() => {
    setConfiguracoes(JSON.parse(localStorage.getItem('configuracoes')));
    localStorage.removeItem('demanda');
    const step = localStorage.getItem('activeStep');

    if (step) setActiveStep(parseInt(step, 10));
    incluirDemanda();
  }, []);

  useEffect(() => {
    localStorage.setItem('activeStep', activeStep);
    localStorage.setItem('completed', Object.keys(completed).length);
  }, [activeStep, completed]);

  const limparLocalStorage = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('profissionalResponsavel');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('demanda');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('email');
    localStorage.removeItem('celular');
    localStorage.removeItem('telefone');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('salaCirurgia');
  };

  const verificaPendenciasStep = step => {
    if (step === 0) {
      const pendenciasPaciente = JSON.parse(localStorage.getItem('pendenciasPaciente'));
      if (pendenciasPaciente.length > 0) {
        let arrayMensagens = [];
        pendenciasPaciente.forEach(validacao => {
          arrayMensagens = [
            ...arrayMensagens,
            {
              severity: 'warn',
              summary: 'Atenção',
              detail: `Informe ${validacao}`,
              life: '3000',
            },
          ];
        });
        myToast.current.show(arrayMensagens);
        return false;
      }
      const email = localStorage.getItem('email');

      if (email && email !== 'null') {
        if (!email.includes('@')) {
          myToast.current.show({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Formato inválido de email',
          });
          return false;
        }
      }
      const peso = localStorage.getItem('peso');
      if (peso) {
        try {
          const nPeso = parseFloat(peso);
          if (nPeso < 0) {
            myToast.current.show({
              severity: 'warn',
              summary: 'Atenção',
              detail: 'Peso nao pode ser negativo',
            });
            return false;
          }
          if (nPeso > 500) {
            myToast.current.show({
              severity: 'warn',
              summary: 'Atenção',
              detail: 'Peso nao pode ser maior que 500kg',
            });
            return false;
          }
        } catch {
          myToast.current.show({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Peso inválido',
          });

          return false;
        }
      }
    }
    if (step >= 1) {
      const pendenciasSolicitacao = JSON.parse(localStorage.getItem('pendenciasSolicitacao'));
      if (pendenciasSolicitacao.length > 0) {
        let arrayMensagens = [];
        pendenciasSolicitacao.forEach(validacao => {
          arrayMensagens = [
            ...arrayMensagens,
            {
              severity: 'warn',
              summary: 'Atenção',
              detail: `Informe ${validacao}`,
              life: '3000',
            },
          ];
        });
        myToast.current.show(arrayMensagens);
        return false;
      }
    }

    if (step >= 2) {
      const pendenciasCirurgia = JSON.parse(localStorage.getItem('pendenciasCirurgia'));

      const arrayMensagensModeloPedidoCirurgia = [];

      const duracaoEstimada = JSON.parse(localStorage.getItem('duracaoEstimada'));
      const duracaoEstimadaMinimaPermitida = localStorage.getItem('duracaoEstimadaMinimaPermitida');
      const duracaoEstimadaMaximaPermitida = localStorage.getItem('duracaoEstimadaMaximaPermitida');
      if (duracaoEstimadaMinimaPermitida && duracaoEstimadaMaximaPermitida) {
        if (
          duracaoEstimada < duracaoEstimadaMinimaPermitida ||
          duracaoEstimada > duracaoEstimadaMaximaPermitida
        ) {
          arrayMensagensModeloPedidoCirurgia.push({
            severity: 'warn',
            summary: 'Atenção',
            detail: `A duração estimada deve estar entre ${duracaoEstimadaMinimaPermitida} minutos e ${duracaoEstimadaMaximaPermitida} minutos!`,
            life: '3000',
          });
        }
      }

      if (arrayMensagensModeloPedidoCirurgia.length > 0) {
        myToast.current.show(arrayMensagensModeloPedidoCirurgia);
        return false;
      }

      if (pendenciasCirurgia.length > 0) {
        let arrayMensagens = [];
        pendenciasCirurgia.forEach(validacao => {
          arrayMensagens = [
            ...arrayMensagens,
            {
              severity: 'warn',
              summary: 'Atenção',
              detail: `Informe ${validacao}`,
              life: '3000',
            },
          ];
        });
        myToast.current.show(arrayMensagens);
        return false;
      }
    }

    return true;
  };

  const reiniciaDemanda = () => {
    limparLocalStorage();
    iniciaPilhaPendencias();
    getConfiguracoes();
    incluirDemanda();
    localStorage.setItem('completed', 0);
  };

  const handleStep = step => async () => {
    if (step === 0) {
      setAbrirDialogConfirmacaoResetaPaciente(true);
      return;
    }

    //  Se clicar nele mesmo, evita as verificações
    if (step === activeStep) return;

    //  Ao voltar os steps também evita as verificações
    if (step < activeStep) {
      setActiveStep(step);
      return;
    }

    //  #region Verifica as pendências
    const pendenciasDeAcordo = verificaPendenciasStep(activeStep);

    if (!pendenciasDeAcordo) {
      setActiveStep(activeStep);
    }
    //  #endregion
  };

  const handleNext = async () => {
    const pendenciasDeAcordo = verificaPendenciasStep(activeStep);

    if (!pendenciasDeAcordo) {
      setActiveStep(activeStep);
      document.location.href = `${document.location.href.replace(
        '#centroWizard',
        ''
      )}#centroWizard`;
      return;
    }
    setActiveStep(activeStep + 1);
    document.location.href = `${document.location.href.replace('#centroWizard', '')}#centroWizard`;
  };

  const handleBack = () => {
    if (activeStep - 1 === 0) setAbrirDialogConfirmacaoResetaPaciente(true);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <PacientePedidoPadrao />;
      case 1:
        return <DadosSolicitacao />;
      case 2:
        return <ItensCirurgia />;
      case 3:
        return <Resumo />;
      default:
        throw new Error('Unknown step');
    }
  }

  //  #region geral
  function incluirDemanda() {
    const demanda = localStorage.getItem('demanda');

    if (demanda) return;

    dominioDemandaCirurgica.post('/api/demanda').then(
      response => {
        localStorage.setItem('demanda', JSON.stringify(response.data));
      },
      () => { }
    );
  }

  const handleCancelarDemanda = () => {
    limparLocalStorage();

    setActiveStep(0);
    setRedireciona(true);
  };

  const handleSalvaDemanda = async () => {
    setLoading(true);

    const paciente = JSON.parse(localStorage.getItem('paciente'));
    const atendimento = JSON.parse(localStorage.getItem('atendimento'));
    const convenio = JSON.parse(localStorage.getItem('convenio'));
    const peso = localStorage.getItem('peso');
    const profissionalResponsavel = JSON.parse(localStorage.getItem('profissionalResponsavel'));
    const dataSugerida = localStorage.getItem('dataSugerida');
    const centroCirurgico = JSON.parse(localStorage.getItem('centroCirurgico'));
    const lateralidade = localStorage.getItem('lateralidade');
    const indicacaoClinica = localStorage.getItem('indicacaoClinica');
    const cidPrincipal = JSON.parse(localStorage.getItem('cidPrincipal'));
    const cidsSecundarios = JSON.parse(localStorage.getItem('cidsSecundarios'));
    const tipoAcomodacao = JSON.parse(localStorage.getItem('tipoAcomodacao'));
    const internacao = JSON.parse(localStorage.getItem('internacao'));
    const diariasPrevistas = localStorage.getItem('diariasPrevistas');
    const leitoUTI = localStorage.getItem('leitoUTI');
    const caixasOPME = JSON.parse(localStorage.getItem('caixasOPME'));
    const materiaisConsumiveis = JSON.parse(localStorage.getItem('materiaisConsumiveis'));
    const caixasCirurgicas = JSON.parse(localStorage.getItem('caixasCirurgicas'));
    const hemoderivados = JSON.parse(localStorage.getItem('hemoderivados'));
    const procedimentoPrincipal = JSON.parse(localStorage.getItem('procedimentoPrincipal'));
    const procedimentosSecundarios = JSON.parse(localStorage.getItem('procedimentosSecundarios'));
    const demanda = JSON.parse(localStorage.getItem('demanda'));
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    const equipamentos = JSON.parse(localStorage.getItem('equipamentos'));
    const codigoLeito = paciente?.COD_LEITO;
    const duracaoEstimada = localStorage.getItem('duracaoEstimada');
    const telefone = localStorage.getItem('telefone');
    const celular = localStorage.getItem('celular');
    const email = localStorage.getItem('email');
    const exames = JSON.parse(localStorage.getItem('exames'));
    const dataInternacao = localStorage.getItem('dataInternacao');
    const eOncologica = JSON.parse(localStorage.getItem('eOncologica'));

    let idPaciente = 0;
    let idAtendimento = 0;
    let idInternacao = 0;

    try {
      const dataNascimento = new Date(paciente.DAT_NASCIMENTO);
      dataNascimento.setDate(dataNascimento.getDate() + 1);
      dataNascimento.setMonth(dataNascimento.getMonth());
      const dataNascimentoFormat = `${dataNascimento.getFullYear()}-${(
        dataNascimento.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}-${dataNascimento
          .getDate()
          .toString()
          .padStart(2, '0')}`;

      const dadosPaciente = {
        idLegado: paciente.SEQ_PACIENTE,
        numeroProntuario: paciente.NRO_PRONTUARIO,
        nome: paciente.NOM_PESSOA,
        dataNascimento: dataNascimentoFormat,
        sexo: paciente.COD_SEXO,
        email,
        telefone,
        celular,
        GMR: paciente?.GMR === 'S' ?? undefined,
      };

      const [responsePaciente] = await Promise.all([
        dominioDemandaCirurgica.post('/api/paciente', dadosPaciente),
      ]);

      idPaciente = responsePaciente.data.id;

      const dadosAtendimento = {
        idLegado: atendimento?.SEQ_ATENDIMENTO ?? paciente?.SEQ_ATENDIMENTO,
        dataAtendimento: atendimento?.DAT_HORA_ATENDIMENTO ?? paciente?.DAT_HORA_ATENDIMENTO,
        numeroFAA: atendimento?.NRO_FAA ?? paciente?.NRO_FAA,
        peso: parseInt(peso, 10),
        convenio: convenio.id,
      };

      const [responseAtendimento] = await Promise.all([
        dominioDemandaCirurgica.post('/api/atendimento', dadosAtendimento),
      ]);

      idAtendimento = responseAtendimento.data.id;

      let dataInternacaoFormat;

      if (dataInternacao) dataInternacaoFormat = new Date(dataInternacao).toISOString();
      else if (dataSugerida) dataInternacaoFormat = new Date(dataSugerida).toISOString();

      const dadosInternacao = {
        diariasPrevistas: parseInt(diariasPrevistas, 10),
        leitoUTI: leitoUTI === 'true',
        tipoAcomodacao: tipoAcomodacao ? tipoAcomodacao.id : null,
        dataInternacao: internacao ? internacao.DAT_HORA_INTERNACAO : dataInternacaoFormat || null,
        idLegado: internacao ? internacao.SEQ_INTERNACAO : undefined,
        numeroInternacao: internacao ? internacao.NRO_INTERNACAO : undefined,
        convenio: convenio.id,
        peso: parseInt(peso, 10),
      };

      const [responseInternacao] = await Promise.all([
        dominioDemandaCirurgica.post('/api/internacao', dadosInternacao),
      ]);
      idInternacao = responseInternacao.data.id;

      const dadosDemanda = {
        atendimento: idAtendimento,
        paciente: idPaciente,
        status: configuracoes.statusInicialDemanda,
        motivoRejeicao: '',
        profissionalInclusao: profissional.profissional_id,
        dataHoraSugerida: dataSugerida,
        profissionalResponsavel: profissionalResponsavel.id,
        centroCirurgico: centroCirurgico.id,
        lateralidade,
        indicacaoClinica,
        cidPrincipal: cidPrincipal ? cidPrincipal.id : null,
        cidSecundario: cidsSecundarios ? cidsSecundarios.map(cid => cid.id) : [],
        internacao: idInternacao,
        procedimentoPrincipal: procedimentoPrincipal.id,
        quantidadeProcedimentoPrincipal: procedimentoPrincipal.quantidade,
        procedimentoSecundario: procedimentosSecundarios
          ? procedimentosSecundarios.map(proc => {
            const p = { id: proc.id, quantidade: proc.quantidade };
            return p;
          })
          : [],
        salvo: 1,
        duracaoEstimada,
        equipeRequisitante: profissional.equipe_id,
        codigoLeitoInternacao: parseInt(codigoLeito, 10),
        ano0: null,
        eOncologica: eOncologica.id,
      };
      const responseDemanda = await Promise.resolve(
        dominioDemandaCirurgica.put(`/api/demanda/${demanda.id}`, dadosDemanda).then(
          () => {
            return true;
          },
          () => {
            setLoading(false);
            setTituloErro('Atenção!');
            setMensagemErro('Erro ao confirmar demanda');
            setAbrirMensagemErro(true);
            return false;
          }
        )
      );
      if (!responseDemanda) return;

      const listaItens = [];
      if (caixasOPME) {
        caixasOPME.forEach(caixa =>
          listaItens.push({
            item: caixa.id,
            quantidade: caixa.quantidade,
            demanda: demanda.id,
            itemEventual: caixa.itemEventual ?? false,
            justificativaEventual: caixa.justificativaEventual ?? null,
          })
        );
      }
      if (materiaisConsumiveis) {
        materiaisConsumiveis.forEach(material =>
          listaItens.push({
            item: material.id,
            quantidade: material.quantidade,
            demanda: demanda.id,
            itemEventual: material.itemEventual ?? false,
            justificativaEventual: material.justificativaEventual ?? null,
          })
        );
      }
      if (hemoderivados) {
        hemoderivados.forEach(hemoderivado =>
          listaItens.push({
            item: hemoderivado.id,
            quantidade: hemoderivado.quantidade,
            demanda: demanda.id,
            unidadeMedida: hemoderivado.unidadeMedida.id,
          })
        );
      }
      if (equipamentos) {
        equipamentos.forEach(equipamento =>
          listaItens.push({
            item: equipamento.id,
            quantidade: 1,
            demanda: demanda.id,
          })
        );
      }
      if (exames) {
        exames.forEach(exame =>
          listaItens.push({
            item: exame.id,
            quantidade: 1,
            demanda: demanda.id,
          })
        );
      }
      if (caixasCirurgicas) {
        caixasCirurgicas.forEach(caixa =>
          listaItens.push({
            item: caixa.id,
            quantidade: 1,
            demanda: demanda.id,
          })
        );
      }
      if (listaItens.length > 0) {
        await Promise.all(
          listaItens.map(async item => {
            await dominioDemandaCirurgica.post('/api/itemDemanda', item);
          })
        );
      }

      limparLocalStorage();
      setRedireciona(true);
    } catch (error) {
      setLoading(false);
      setTituloErro('Atenção!');
      setMensagemErro(`Erro ao confirmar demanda: ${error}`);
      setAbrirMensagemErro(true);
      console.log(error);
    }
  };

  const handleConfirmarDemanda = async () => {
    setLoading(true);

    const peso = localStorage.getItem('peso');
    const profissionalResponsavel = JSON.parse(localStorage.getItem('profissionalResponsavel'));
    const centroCirurgico = JSON.parse(localStorage.getItem('centroCirurgico'));
    const diariasPrevistas = localStorage.getItem('diariasPrevistas');
    const eOncologica = JSON.parse(localStorage.getItem('eOncologica'));
    const tipoAcomodacao = JSON.parse(localStorage.getItem('tipoAcomodacao'));
    const internacao = JSON.parse(localStorage.getItem('internacao'));

    if (!profissionalResponsavel) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo profissional responsável é obrigatório`.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!centroCirurgico) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo centro cirurgico é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    //  #region Validações
    if (parseInt(peso, 10) > 500) {
      setTituloErro('Atenção!');
      setMensagemErro('O peso máximo é 500.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (parseInt(diariasPrevistas, 10) > 999) {
      setTituloErro('Atenção!');
      setMensagemErro('O máximo de diárias previstas é 999.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (eOncologica === null) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe se é ou não uma cirurgia oncológica.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    //  #endregion
    setAbrirDialogConfirmacaoSalaCirurgica(true);
  };

  const renderFooterDisplay = () => {
    return (
      <div>
        <ButtonPrime
          label="Não"
          icon="pi pi-times"
          onClick={() => setDisplayBasica(false)}
          className="p-button-text"
        />
        <ButtonPrime
          label="Sim"
          icon="pi pi-check"
          onClick={() => handleCancelarDemanda()}
          autoFocus
        />
      </div>
    );
  };

  const renderFooterDisplayErro = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => setAbrirMensagemErro(false)}
          autoFocus
        />
      </div>
    );
  };

  const renderFooterDisplayConfirmacaoResetaPaciente = () => {
    return (
      <div>
        <ButtonPrime
          label="Confirmar"
          icon="pi pi-check"
          onClick={() => {
            setAbrirDialogConfirmacaoResetaPaciente(false);
            reiniciaDemanda();
            setActiveStep(stepInicial);
            document.location.href = `${document.location.href.replace(
              '#centroWizard',
              ''
            )}#centroWizard`;
          }}
          autoFocus
        />
      </div>
    );
  };

  const renderFooterDisplayConfirmacaoSalaCirurgica = () => {
    return (
      <div>
        <ButtonPrime
          label="LI E CONCORDO"
          icon="pi pi-check"
          onClick={() => {
            setAbrirDialogConfirmacaoSalaCirurgica(false);
            handleSalvaDemanda();
          }}
          autoFocus
        />
      </div>
    );
  };

  if (redireciona) {
    return <Redirect from="/admin" to="/admin/minhasDemandas" />;
  }

  //  #endregion

  return (
    <>
      <Toast ref={myToast} />
      <CssBaseline />
      <main className={classes.layout}>
        <Dialog
          header="Atenção"
          visible={abrirDialogConfirmacaoResetaPaciente}
          modal
          style={{ width: '60vw' }}
          footer={renderFooterDisplayConfirmacaoResetaPaciente()}
          onHide={() => setAbrirDialogConfirmacaoResetaPaciente(false)}
        >
          <div className="confirmation-content">
            <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
            <span>
              {
                '  Se voltar para a aba de Paciente, todos os dados da demanda serão perdidos. Deseja realmente voltar?'
              }
            </span>
          </div>
        </Dialog>
        <Dialog
          header="ATENÇÃO!"
          visible={abrirDialogConfirmacaoSalaCirurgica}
          modal
          style={{ width: '25vw' }}
          footer={renderFooterDisplayConfirmacaoSalaCirurgica()}
          onHide={() => setAbrirDialogConfirmacaoSalaCirurgica(false)}
        >
          <div style={{ justifyItems: 'center' }}>
            <span
              style={{
                whiteSpace: 'pre-line',
                display: 'table',
                margin: '0 auto',
                textAlign: 'center',
              }}
            >
              Esclarecemos que a inclusão de uma
              <b> demanda </b>
              não
              <br />
              significa o início de um
              <b> pedido de cirurgia. </b>
              <br />
              A inclusão de pedidos deve ser realizada pela tela “Meus pedidos”
              <br />
              ou por meio do botão de ação “Transformar em pedido”,
              <br />
              presente na tela “Minhas Demandas”.
            </span>
          </div>
        </Dialog>
        <Dialog
          header="Cancelar demanda"
          visible={displayBasic}
          style={{ width: '60vw' }}
          footer={renderFooterDisplay()}
          onHide={() => setDisplayBasica(false)}
        >
          <p>Deseja realmente cancelar?</p>
        </Dialog>
        <Dialog
          header={tituloErro}
          visible={abrirMensagemErro}
          style={{ width: '65vw' }}
          onHide={() => setAbrirMensagemErro(false)}
          footer={renderFooterDisplayErro()}
        >
          <div>
            <span style={{ whiteSpace: 'pre-line' }}>{Parser(mensagemErro)}</span>
          </div>
        </Dialog>
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4" align="center" id="centroWizard">
            Demanda Cirúrgica
          </Typography>
          {isMobile ? (
            <div>
              <div className="div-stepper-mobile">
                <strong className="texto-stepper-mobile">{`${activeStep + 1} - `}</strong>
                <span className="texto-stepper-mobile">{steps[activeStep]}</span>
              </div>
              <MobileStepper
                variant="dots"
                steps={steps.length}
                position="static"
                activeStep={activeStep}
                className={classes.root}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === steps.length - 1}
                  >
                    Próximo
                    <KeyboardArrowRight />
                  </Button>
                }
                backButton={
                  <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                    <KeyboardArrowLeft />
                    Voltar
                  </Button>
                }
              />
            </div>
          ) : (
            <Stepper nonLinear activeStep={activeStep} className={classes.stepper}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepButton
                    disabled={activeStep === steps.length}
                    onClick={handleStep(index)}
                    completed={completed[index]}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
          )}
          <>
            {activeStep === steps.length ? (
              <ConfirmacaoPedido />
            ) : (
              <>
                {getStepContent(activeStep)}
                <div
                  className={`${classes.buttons} ${activeStep !== 0 ? 'alinhamento-botoes-wizard' : ''
                    }`}
                >
                  {activeStep !== 0 && (
                    <Button
                      id="btnAnt"
                      tabIndex="-1"
                      onClick={handleBack}
                      className={classes.button}
                      color="default"
                      variant="contained"
                    >
                      Anterior
                    </Button>
                  )}
                  <Button
                    id="btnProx"
                    variant="contained"
                    color="primary"
                    onClick={
                      activeStep === steps.length - 1 ? handleConfirmarDemanda : handleComplete
                    }
                    className={classes.button}
                    style={{ float: `` }}
                  >
                    {loading ? (
                      <>
                        <FaSpinner color="#FFF" className="loading" size={14} />
                      </>
                    ) : (
                      <>{activeStep === steps.length - 1 ? 'Enviar' : 'Próximo'}</>
                    )}
                  </Button>
                </div>
              </>
            )}
          </>
        </Paper>
      </main>
    </>
  );
}
